module.exports = __webpack_public_path__ + "img/1-4.f60663d8.jpg";